import React from "react";

const BackToTop = () => {
    return (
        <>
            <a id="back-to-top" title="Go to Top" href="">
                <i className="fas fa-chevron-up"></i>
            </a>
        </>
    )

};

export default BackToTop;
